import React from 'react';
function ReferAFriend({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.5 8a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM16 15a4 4 0 100-8 4 4 0 000 8z"
      />
      <path
        strokeLinecap="round"
        d="M3 12c0-2 2.25-4 4.5-4S12 9.667 12 12M10 21c0-3 3-6 6-6s6 2.5 6 6"
      />
    </svg>
  );
}

export default ReferAFriend;
